(() => {
  const header = document.querySelector('x-header.header');
  if (!header) return;

  const desktop = window.matchMedia('(min-width: 1000px)');

  const paintMargin = () => {
    const section = header.closest('.shopify-section');
    if (!section) return;

    const banner = document.querySelector('main .desktop-banner');
    if (banner && desktop.matches) {
      const photoStillBehind = banner.getBoundingClientRect().bottom > section.getBoundingClientRect().bottom - 1;
      if (photoStillBehind) {
        section.style.backgroundColor = 'transparent';
      } else {
        const surface = document.querySelector('.collection') || document.body;
        const bg = getComputedStyle(surface).backgroundColor;
        section.style.backgroundColor = bg && bg !== 'rgba(0, 0, 0, 0)' ? bg : '#fff';
      }
      return;
    }

    if (!desktop.matches || document.querySelector('[allow-transparent-header]')) {
      section.style.backgroundColor = '';
      return;
    }

    const block = [...document.querySelectorAll('main .shopify-section')].find((el) => el.getBoundingClientRect().height > 8);
    const painted = block?.querySelector('.color-scheme') || block;
    const bg = painted ? getComputedStyle(painted).backgroundColor : '';
    section.style.backgroundColor = bg && bg !== 'rgba(0, 0, 0, 0)' ? bg : '';
  };

  header.addEventListener('mouseover', (event) => {
    const current = event.target.closest('mega-menu-disclosure, dropdown-menu-disclosure');
    if (!current) return;

    header.querySelectorAll('mega-menu-disclosure, dropdown-menu-disclosure').forEach((other) => {
      if (other === current) return;
      if (other.disclosureElement?.getAttribute('aria-expanded') === 'true' && typeof other.close === 'function') {
        other.close();
      }
    });
  });

  const search = header.querySelector('header-search');
  if (search) {
    const clearSearch = () => {
      const form = search.querySelector('form');
      const input = form?.elements?.q;
      if (input) input.value = '';
      search.querySelector('[slot="results"]')?.replaceChildren();
    };
    search.addEventListener('dialog:before-hide', clearSearch);
    search.addEventListener('dialog:after-hide', () => {
      search.querySelector('form')?.reset();
      if (search.contains(document.activeElement)) document.activeElement.blur();
    });
  }

  const boot = () => paintMargin();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('load', boot);
  window.addEventListener('scroll', boot, { passive: true });
  desktop.addEventListener('change', boot);
  requestAnimationFrame(() => requestAnimationFrame(boot));
})();
